// Shared with PoliciesPage and the globally-rendered IssuesDetectedModal/DocumentPreviewModal
// so all three format topic keys (e.g. "returnPolicy") into display labels (e.g. "Return Policy")
// the same way.
const TOPIC_TITLES = {
  storeSetup: "Store setup",
  ordersAndShipping: "Orders and shipping",
  returnsRefundsAndCancellations: "Returns, refunds and cancellations",
  productSupport: "Product support",
  complianceAndEscalation: "Compliance and escalation",
  others: "Others",
};

export const formatTopicKey = key => TOPIC_TITLES[key] ?? key;

// Shared with GlobalDocumentPreviewModal — same overallScore thresholds used for the
// Document Preview Modal's score badge.
export const getScoreLabel = overallScore =>
  overallScore == null
    ? ""
    : overallScore >= 80
      ? "Excellent"
      : overallScore >= 60
        ? "Good"
        : overallScore >= 40
          ? "Fair"
          : "Poor";

export const getScoreBadgeClass = overallScore =>
  overallScore == null
    ? ""
    : overallScore >= 80
      ? "bg-[#E8FFF5] text-[#1DB87B]"
      : overallScore >= 60
        ? "bg-[#EFF6FF] text-[#2563EB]"
        : overallScore >= 40
          ? "bg-[#FFF7ED] text-[#D97706]"
          : "bg-[#FFF5F5] text-[#DC2626]";

// --- Dreams policy suggestions ---------------------------------------------
// Shared by DocumentPreviewModal (rendering) and GlobalDocumentPreviewModal
// (the apply handlers), so the two cannot drift on what counts as a Dreams item.

// A Dreams suggestion carries the learned rule AND the merchant's action. `kind`
// is only written by the policy-suggestion pass, so older Dreams rows and every
// scorer gap fall through to the plain label/evidence rendering.
export const isDreamsSuggestion = item => item?.source === "dreams" && Boolean(item?.rule) && Boolean(item?.kind);

// `update` when the policy states something different, `add` when it is silent.
// Falls back to `status` for a row written before `kind` existed.
export const actionOf = item => item?.kind || (item?.status === "partial" ? "update" : "add");

// The instruction sent to the apply route for a Dreams item. These carry no
// `question` of their own — the card states the finding and pre-fills the policy
// text rather than restating the rule as a sentence to answer — but the route
// pairs a question with the answer, so give it the action in plain words.
export const questionForDreamsItem = item =>
  actionOf(item) === "update"
    ? `Your policy currently says: "${item?.evidence || ""}". Replace that with the following rule, which your team applied in ${item?.occurrences || 0} replies.`
    : `Your policy does not yet state this rule, which your team applied in ${item?.occurrences || 0} replies. Add it.`;
